module.exports = __webpack_public_path__ + "static/media/memelio-taupomoji-kasa.2aa0d8db.png";